import { Component, EventEmitter, Input, Output, OnInit, forwardRef } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ColorAdapter } from '@angular-material-components/color-picker';
import { FormControl, FormGroup, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const colorRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

@Component({
    selector: 'app-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    providers: [
        ColorAdapter,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ColorPickerComponent),
            multi: true,
        },
    ],
})
export class ColorPickerComponent implements OnInit, ControlValueAccessor {
    @Input() defaultColor: string;
    @Input() disabled: boolean = false;
    @Input() formName: string;
    @Output() colorChange = new EventEmitter<string>();
    @Input() colorForm: FormGroup;

    private updating = false;
    touchUi: boolean = true;
    value: string;

    onChange = (_: any) => {};
    onTouch = () => {};

    ngOnInit() {
        this.colorForm.get(this.formName)?.valueChanges.subscribe((color) => {
            if (!this.updating && this.colorForm.valid && color) {
                this.onColorChange(color);
            }
        });
    }

    onColorChange(selectedColor: string) {
        if (colorRegex.test(selectedColor)) {
            this.updating = true;
            try {
                this.defaultColor = selectedColor;
                this.value = selectedColor;
                this.onChange(selectedColor);
                this.onTouch();
                this.colorChange.emit(selectedColor);

                const control = this.colorForm.get(this.formName);
                if (control && control.value !== selectedColor) {
                    control.setValue(selectedColor, { emitEvent: false });
                }
            } finally {
                this.updating = false;
            }
        }
    }
    // ControlValueAccessor methods
    writeValue(value: string): void {
        this.value = value;
        this.onChange(value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    toggleDisabled() {
        this.disabled = !this.disabled;
        if (this.disabled) {
            this.colorForm.disable();
        } else {
            this.colorForm.enable();
        }
    }

    get colorControl() {
        return this.colorForm.get(this.formName);
    }
}
